import Firebase from './Firebase';
import FirebaseContext, { withFirebase } from './Context';

export default Firebase;

export { FirebaseContext, withFirebase };
